
import React, { Component } from 'react'
import { passwordPattern, passwordErrorMessage } from 'lib/validation'
import t from 'tcomb-form'
import Alert from 'ui/Alert'
import Form from 'ui/Form'
import Space from 'ui/Space'
import Button from 'ui/Button'

const Password = t.refinement(t.String, function (s) {
  return new RegExp(passwordPattern).test(s)
})

const FormSchema = t.refinement(t.struct({
  password: Password,
  confirm: Password
}), samePasswords)

function samePasswords (x) {
  return x.newPassword === x.confirmPassword
}

const FormOptions = {
  error: <Alert type='danger'>Passwords must match</Alert>,
  fields: {
    password: {
      error: passwordErrorMessage,
      type: 'password',
      label: 'New Password',
      attrs: { required: true, autoFocus: true }
    },
    confirm: {
      error: passwordErrorMessage,
      type: 'password',
      label: 'Confirm Password',
      attrs: { required: true }
    }
  }
}

class ResetForm extends Component {
  render () {
    return (
      <div className='ResetForm'>
        <Form schema={FormSchema} options={FormOptions} onSubmit={this.props.onSubmit}>
          <Space value='20' />
          <Button type='submit' icon='arrow' extras='fluid'>
            Reset your password
          </Button>
        </Form>
      </div>
    )
  }
}

export default ResetForm



// WEBPACK FOOTER //
// ./components/ResetForm.js